// アイテム登録画面で、既に同名のアイテムが登録されていないか確認する
$('#itemsRegisterConfirmModal').on('show.bs.modal', (e) => {
  const registerItems = JSON.parse($('#items-json').val())
  const names = JSON.parse(e.currentTarget.dataset.itemNames)
  const namesMap = new Map(names.map((name) => [name, 1]))

  const check = registerItems.some((item) => namesMap.has(item.name))
  if (check) {
    $('#alert-items-register').removeClass('d-none')
  } else {
    $('#alert-items-register').addClass('d-none')
  }
})
